import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactQuill from 'react-quill';

import {
  Message as MessageActions,
} from '../../../../redux/actions';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';


import Message from './Message';

const editorFormats = [
  'font',
  'bold',
  'italic',
  'underline',
  'blockquote',
  'code-block',
  'list',
  'indent',
];

const editorModules = {
  toolbar: [
    [{ font: [] }, 'bold', 'italic', 'underline', 'blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: true,
  },
};

const messageStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(1)
  },
  loadingThrobber: {
    display: 'flex',
    '& > *': {
      margin: 'auto'
    }
  },
}));

const MessageList = (props) => {
  const classes = messageStyles();
  const [messageDisplay, setMessageDisplay] = useState(null)
  const [pendingMessage, setPendingMessage] = useState("")

  useEffect( () => {
    if (props.messages === false){
      setMessageDisplay(<div className={classes.loadingThrobber}><CircularProgress /></div>)
    } else if (props.messages.length === 0){
      setMessageDisplay(<div className={classes.loadingThrobber}><Typography>No messages</Typography></div>)
    } else {
      const retVal = []
      props.messages.map(message => { /* eslint-disable-line */
        retVal.push(<Message key={message.id} {...message} />)
      })
      setMessageDisplay(retVal)
    }
  }, [props.messages]) /* eslint-disable-line */

  const updatePendingMessage = (value) => {
    setPendingMessage(value)
  }

  const sendMessage = () => {
    props.dispatch(
      MessageActions.saveCommentForFinding({
        body: pendingMessage,
        findingId: props.findingId,
        orgId: props.orgId,
      })
    )
    setPendingMessage()
  }

  return (
    <div>
      <div>
        {messageDisplay}
      </div>
      <Paper elevation={0} variant="outlined" className={classes.paper}>
        <ReactQuill
          formats={editorFormats}
          modules={editorModules}
          placeholder=""
          value={pendingMessage}
          onChange={updatePendingMessage}
          style={{
            width: '100%',
            backgroundColor: '#FFF',
          }}
        />
      </Paper>
      <Button onClick={sendMessage} variant="contained" color="primary">Submit</Button>
    </div>
  )
}

export default MessageList